module.exports = "../content/3ca75c6714e3d31a728533e20f669181.woff2";